import {
  gCollectionCountUrl,
  GET_ALL_ACTIVE_SEEDSPECIES_CROPS_URL,
  GET_ALL_ACTIVE_SUPPLIER_NAMES_URL,
  GET_ALL_ACTIVE_UNIT_URL,
  GET_ALL_GORGANISATION_URL,
  GET_SEEDSPECIES_BY_ID_URL,
  G_SEARCH_API_URL,
  REFERENCE_COLLECTION_URLS,
  REGULAR_COLLECTION_URLS,
} from 'constants/Constant';
import { GSeedSpecies, IGOrganisation } from 'interfaces/IGlobalCatalogue';
import { GSearchParam } from 'types/GlobalCatalogueTypes';
import axiosInstance from './AxiosInstance';

export const GlobalCatalogueService = {
  FetchGReferenceCollectionData: async (collectionName: string) => {
    const response = await axiosInstance.get(
      REFERENCE_COLLECTION_URLS.GET[
        collectionName as keyof typeof REFERENCE_COLLECTION_URLS.GET
      ]
    );
    return response.data;
  },

  FetchGRegularCollectionData: async (
    collectionName: string,
    activeGOrganisation: string,
    pageSize: number,
    pageIndex: number,
    segmentId?: string,
    signal?: AbortSignal
  ) => {
    const baseUrl =
      REGULAR_COLLECTION_URLS.GET[
        collectionName as keyof typeof REGULAR_COLLECTION_URLS.GET
      ] +
      '/' +
      activeGOrganisation +
      '/Size/' +
      pageSize +
      '/Page/' +
      pageIndex;

    const url = segmentId ? `${baseUrl}/Segment/${segmentId}` : baseUrl;

    const response = await axiosInstance.get(url, { signal });
    return response.data;
  },

  FetchGOrganisationData: async (): Promise<IGOrganisation[]> => {
    const response = await axiosInstance.get<IGOrganisation[]>(
      GET_ALL_GORGANISATION_URL
    );
    return response.data;
  },

  FetchGUnitData: async (_: unknown, activeGOrganisation: string) => {
    const response = await axiosInstance.get(
      GET_ALL_ACTIVE_UNIT_URL + '/' + activeGOrganisation,
      { _silentErrors: true }
    );
    return response.data;
  },

  FetchGOperationUnit: async (
    activeGOrganisation: string,
    category: number
  ) => {
    const response = await axiosInstance.get(
      GET_ALL_ACTIVE_UNIT_URL +
        '/' +
        activeGOrganisation +
        '/Category/' +
        category
    );
    return response.data;
  },

  FetchGUnitParameterById: async (
    activeGOrganisation: string,
    parameterId: string
  ) => {
    const response = await axiosInstance.get(
      GET_ALL_ACTIVE_UNIT_URL +
        '/' +
        activeGOrganisation +
        '/Parameter/' +
        parameterId
    );
    return response.data;
  },

  FetchAllActiveGSeedSpeciesCrops: async (activeGOrganisation: string) => {
    const response = await axiosInstance.get(
      GET_ALL_ACTIVE_SEEDSPECIES_CROPS_URL +
        activeGOrganisation +
        '/AllActiveCrops'
    );
    return response.data;
  },

  FetchGSeedSpeciesById: async (id: string): Promise<GSeedSpecies> => {
    const response = await axiosInstance.get<GSeedSpecies>(
      GET_SEEDSPECIES_BY_ID_URL + encodeURIComponent(id)
    );
    return response.data;
  },

  FetchAllActiveGSupplierNames: async () => {
    const response = await axiosInstance.get(GET_ALL_ACTIVE_SUPPLIER_NAMES_URL);
    return response.data;
  },

  FetchGCollectionTotalPages: async (
    activeGOrganisation: string,
    pageSize: number,
    segmentId: string,
    collectionName: string
  ) => {
    const baseUrl =
      gCollectionCountUrl(collectionName) +
      '/' +
      activeGOrganisation +
      '/Size/' +
      pageSize;

    const url = segmentId ? `${baseUrl}/Segment/${segmentId}` : baseUrl;

    const response = await axiosInstance.get(url);
    return response.data;
  },

  CreateGCollectionData: async (collectionName: string, params: object) => {
    const baseUrl =
      REFERENCE_COLLECTION_URLS.CREATE[
        collectionName as keyof typeof REFERENCE_COLLECTION_URLS.CREATE
      ] ||
      REGULAR_COLLECTION_URLS.CREATE[
        collectionName as keyof typeof REGULAR_COLLECTION_URLS.CREATE
      ];

    if (!baseUrl) {
      throw new Error(`Invalid collectionName: ${collectionName}`);
    }

    const response = await axiosInstance.post(baseUrl, params);
    return response.data;
  },

  UpdateGCollectionData: async (collectionName: string, params: object) => {
    const baseUrl =
      REFERENCE_COLLECTION_URLS.UPDATE[
        collectionName as keyof typeof REFERENCE_COLLECTION_URLS.UPDATE
      ] ||
      REGULAR_COLLECTION_URLS.UPDATE[
        collectionName as keyof typeof REGULAR_COLLECTION_URLS.UPDATE
      ];

    if (!baseUrl) {
      throw new Error(`Invalid collectionName: ${collectionName}`);
    }

    const response = await axiosInstance.put(baseUrl, params);
    return response.data;
  },

  DeleteGCollectionData: async (collectionName: string, id: string) => {
    const baseUrl =
      REFERENCE_COLLECTION_URLS.DELETE[
        collectionName as keyof typeof REFERENCE_COLLECTION_URLS.DELETE
      ] ||
      REGULAR_COLLECTION_URLS.DELETE[
        collectionName as keyof typeof REGULAR_COLLECTION_URLS.DELETE
      ];

    if (!baseUrl) {
      throw new Error(`Invalid collectionName: ${collectionName}`);
    }

    const response = await axiosInstance.delete(`${baseUrl}/${id}`);
    return response.data;
  },

  SearchGCollectionData: async (searchParams: GSearchParam) => {
    const response = await axiosInstance.post(G_SEARCH_API_URL, searchParams);
    return response.data;
  },
};
